<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Collection Report</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Report</li>
                  <li class="breadcrumb-item active">Collection Report</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Filter Report</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-4">
                      <label class="form-label" for="title">Customer</label>

                      <Select2 v-model="customer_id" :options="customerList" />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label" for="title">Customer Type</label>
                      <select v-model="customer_type" class="form-control">
                        <option value="" disabled>Select type</option>
                        <option value="0">All</option>
                        <option v-for="item in this.customerTypeList" :key="item.id" :value="item.id">
                          {{ item.title }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label" for="title">Select District</label>
                      <!-- <select v-model="district_id" class="form-control">
                        <option value="" disabled>Select district</option>
                        <option value="0">All</option>
                        <option
                          v-for="item in this.districtList"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select> -->
                      <Select2 v-model="district_id" :options="districtList" @select="mySelectDistrictEvent($event)" />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label" for="status">From Date</label>
                      <input v-model="from_date" class="form-control" id="status" type="date" placeholder="Enter Date"
                        aria-describedby="inputGroupPrepend" required />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label" for="status">To Date</label>
                      <input v-model="to_date" class="form-control" id="status" type="date" placeholder="Enter Date"
                        aria-describedby="inputGroupPrepend" required />
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit" @click="onFilterAction">
                    Submit
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>

            <!-- Data table -->
            <div class="col-sm-12 col-lg-12" v-show="collectionReport.length > 0">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                </div>
                <div class="card-body">
                  <div class="col-12 text-end">
                    <button class="btn btn-primary" @click="downloadPDF">
                      Download Report
                    </button>
                  </div>
                  <div class="table-responsive product-tabl">
                    <table class="display w-100">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Customer</th>
                          <th>District</th>
                          <th>Invoice no.</th>
                          <th>Payment Method</th>
                          <th>MR Number</th>
                          <th>MR Date</th>
                          <th>Recieve Date</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" v-for="(item, index) in collectionReport" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>
                            {{
                              customerList
                                .map((e) => e.id === item.customer_id && e.name)
                                .filter(Boolean)
                                .toString()
                            }}
                          </td>
                          <td>
                            {{
                              districtList
                                .map((e) => e.id === item.district && e.name)
                                .filter(Boolean)
                                .toString()
                            }}
                          </td>
                          <td>{{ "#INV" + item.invoice_id }}</td>
                          <td>
                            {{
                              item.payment_method === 1
                              ? "Cash"
                              : item.payment_method === 2
                                ? "Bank"
                                : item.payment_method === 3
                                  ? "bKash"
                                  : "Chalan"
                            }}
                          </td>
                          <td>{{ item.mr_number }}</td>
                          <td>{{ item.mr_date }}</td>
                          <td>{{ item.receive_date }}</td>
                          <td>{{ item.amount }}</td>

                          <td>
                            <button class="btn btn-primary btn-xs" type="button" :disabled="!this.filter === {}"
                              @click="downloadPDFPaymentInvoice(item)">
                              Print
                            </button>

                            <button class="btn btn-primary btn-xs" type="button" data-bs-toggle="modal"
                              data-bs-target="#exampleModal1" @click.prevent="selectedAction(item)">
                              <span class="title"> Details</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="col-12 text-end mt-5">
                      <h5>Total Amount : {{ totalAmount ? totalAmount : "N/A" }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
        <!-- Container-fluid starts-->
        <!-- Modal -->
        <div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1"
          aria-hidden="true" v-show="this.selectedItem">
          <div class="modal-dialog modal-dialog modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel1">Details</h5>
                <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body ct">
                <h5>Bank Name : {{ this.selectedItem.bank_name }}</h5>
                <hr />
                <h5>Bank Branch : {{ this.selectedItem.bank_branch }}</h5>
                <hr />
                <h5>Cheque Number : {{ this.selectedItem.cheque_number }}</h5>
                <hr />
                <h5>Cheque Date : {{ this.selectedItem.cheque_date }}</h5>
                <hr />
                <h5>Bkash Date : {{ this.selectedItem.bkash_date }}</h5>
                <hr />
                <h5>Bkash Transaction : {{ this.selectedItem.bkash_transaction_id }}</h5>
                <hr />
                <h5>Reference : {{ this.selectedItem.bkash_transfer_reference }}</h5>
                <hr />
                <h5>
                  Customer Type :
                  {{ this.selectedItem.customer_type == 1 ? "General" : "VIP" }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import areaRelatedAPI from "../../../services/areaRelatedAPI.js";
import ReportAPI from "../../../services/report.API.js";
// import $ from "jquery";
import customerAPI from "../../../services/customer.API.js";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import connectionTypeAPI from "../../../services/connectionType.API.js";
import Select2 from "vue3-select2-component";

export default {
  name: "collectionReport",
  components: {
    Select2,
  },
  data() {
    return {
      customer_type: 0,
      customer_id: 0,
      district_id: 0,
      customerList: [{ id: 0, text: "All" }],
      from_date: moment(new Date()).format("yyyy-MM-DD"),
      to_date: moment(new Date()).format("yyyy-MM-DD"),
      collectionReport: [],
      districtList: [],
      selectedItem: "",
      totalAmount: 0,
      customerTypeList: [],
    };
  },
  methods: {
    mySelectDistrictEvent({ id }) {
      this.district_id = id;
    },

    // addNew
    onFilterAction() {
      //   console.log(this.title, this.status);
      console.log("customer_id : " + this.customer_id);

      let data = {
        customer_type: Number(this.customer_type),
        customer_id: Number(this.customer_id),
        district_id: Number(this.district_id),
        from_date: this.from_date,
        to_date: this.to_date,
      };
      ReportAPI.getCollectionReport(data)
        .then((response) => {
          if (response?.data?.data?.length === 0) {
            this.$moshaToast("No data found", {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
            this.collectionReport = response.data.data;
          }
          //   list
          this.totalAmount = response.data.totalAmount;
          this.collectionReport = response.data.data.map((e) => {
            return {
              ...e,
              mr_date: moment(e.mr_date).format("MMMM DD, YYYY"),
              receive_date: moment(e.receive_date).format("MMMM DD, YYYY"),
              cheque_date: moment(e.cheque_date).format("MMMM DD, YYYY"),
              bkash_date: moment(e.bkash_date).format("MMMM DD, YYYY"),
            };
          });
          // setTimeout(() => {
          //   $("#collectionReportTBL").DataTable({
          //     lengthMenu: [
          //       [10, 25, 50, -1],
          //       [10, 25, 50, "All"],
          //     ],
          //     pageLength: 10,
          //     info: false,
          //     targets: "no-sort",
          //     bSort: false,
          //     order: [],
          //     bFilter: true,
          //     bInfo: false,
          //     //   bLengthChange: false,
          //     bDestroy: true,
          //   });
          // });
        })
        .catch((error) => {
          // console.log(error.response.data.success);
          if (error.response.data.success === false) {
            this.$moshaToast(error.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        });
    },

    selectedAction(item) {
      this.selectedItem = item;
    },

    setPrintText(
      doc = undefined,
      text = "",
      widthPosition = 0,
      heightPosition = 0
      // fontStyle = undefined,
      // fontSize = undefined
    ) {
      if (doc !== undefined) {
        doc.setFontSize(10);
        doc.text(text, widthPosition, heightPosition, { align: "center" });
      }
    },

    // download pdf
    downloadPDF() {
      console.log("submit pdf");
      const unit = "pt";
      const size = "A4"; // Use A1, A2, A3 or A4
      const orientation = "portrait"; // portrait or landscape

      // header/body data
      const columns = [
        [
          "Invoice No.",
          "Customer",
          "District",
          "Payment Method",
          "MR Number",
          "MR Date",
          "Recieve Date",
          "Amount",
        ],
      ];
      const data = this.collectionReport.map((e) => [
        "#INV" + e.invoice_id,
        this.customerList
          .map((ee) => ee.id === e.customer_id && ee.name)
          .filter(Boolean)
          .toString(),
        this.districtList
          .map((e2) => e2.id === e.district && e2.name)
          .filter(Boolean)
          .toString(),
        e.payment_method === 1 ? "Cash" : e.payment_method === 2 ? "Bank" : e.payment_method === 3 ? "bKash" : "Chalan",
        e.mr_number,
        e.mr_date,
        e.receive_date,
        e.amount,
      ]);

      // alignment
      const marginLeft = 40;
      const doc = new jsPDF(orientation, unit, size);
      // new line
      // var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      doc.setFontSize(12);

      doc.text("Total Amount : " + this.totalAmount, 40, 85);

      doc.setFontSize(15);
      var startingPage = doc.internal.getCurrentPageInfo().pageNumber;
      const title = "Collection Report";

      let content = {
        startY: 120,
        head: columns,
        body: data,
        margin: {
          bottom: 120,
          top: 150,
        },
      };

      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);
      doc.text(title, marginLeft, 50);

      doc.autoTable(content);

      doc.setPage(startingPage);
      doc.save("Collection_Report(" + moment(new Date()).format("YYYY-MM-DD") + ").pdf"); // Auto print code
      doc.autoPrint();
    },

    async downloadPDFPaymentInvoice(item) {
      let converter = require('number-to-words');

      console.log(item);
      console.log(item.customer_id);

      // customerAPI.getDetails(item.customer_id).then((response) => {
      //   this.customerList = response.data.data;
      // });

      let customerName = "";
      try {
        let customerDetails = await customerAPI.getDetails(item.customer_id);
        if (customerDetails.data.success) {
          customerName = customerDetails.data.data.name;
        }
      } catch (error) { customerName = "error"; }



      let today = moment(new Date()).format("DD MMMM, YYYY  h:mm a");
      let payment_method = item.payment_method == 1 ? "CASH" : (item.payment_method == 2) ? "BANK" : (item.payment_method == 3) ? "BKash" : "Chalan";
      let amount_tk_word = converter.toWords(item.amount);

      let data = {
        "invoice_no": item.id.toString(),
        "customer_name": customerName,
        "mr_number": item.mr_number,
        "mr_date": item.mr_date,
        "received_date": item.receive_date,
        "amount_tk": item.amount,
        "amount_tk_word": amount_tk_word + " tk only",
        "payment_method": payment_method,
        "note": item.note,
        "bkash_date": item.bkash_date,
        "transection_id": item.bkash_transaction_id,
        "reference": item.bkash_transfer_reference,
        "bank_name": item.bank_name,
        "bank_branch": item.bank_branch,
        "cheque_number": item.cheque_number,
        "cheque_date": item.cheque_date,
        "chalan_no": item.chalan_no,
        "copy_right_message": "This is system generated invoice no signature required. Invoice Print Date: " + today
      };

      var doc = new jsPDF("p", "pt", "a4", true);

      doc.setFontSize(40);

      let tempMisHight = 65;
      let tempMisWidth = 40;

      var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();


      doc.setFontSize(20);
      doc.text("INFOCOM LIMITED", tempMisWidth + 260, tempMisHight + 25, { align: "center" });

      var img = new Image();
      img.src = 'images/sample.png';
      doc.addImage(img, 'png', pageWidth - 100, 30, 80, 35);

      // this.setPrintText(doc, "HEAD OFFICE: ", tempMisWidth + 100, tempMisHight + 45, "bold", 10);
      // this.setPrintText(doc, "Udoy Tower, (9th floor), Plot # 57 & 57/A, Gulshan Avenue, Dhaka 1212", tempMisWidth + 298, tempMisHight + 45, "normal", 56);
      // this.setPrintText(doc, "Tel: 88-02-9860906, 88-02-8816282, 99-028837430-33, 88-02-9892169, Cell: +88 0181941241 ", tempMisWidth + 260, tempMisHight + 58, "normal", 56);
      // this.setPrintText(doc, "E-mail: info@aktelecom.net; help@aktelecom.net; Web: www.aktelecom.net", tempMisWidth + 260, tempMisHight + 71, "normal", 56);

      doc.setFontSize(6);
      this.setPrintText(doc, "Corporate Office: Uday tower, (9th floor), Plot # 57 & 57/A, Gulshan Avenue, Dhaka-1212.IP Phone: +88-9614224466", tempMisWidth + 265, tempMisHight + 45, "bold", 10);
      this.setPrintText(doc, "Cell: +88-01819412413, Tel: +88-02222299603, +88-02222292169, +88-02222287485, +88-029887485", tempMisWidth + 270, tempMisHight + 56, "normal", 56);
      this.setPrintText(doc, "Head Office: Batali Hills, Ambagan, Chattogram -4000, Tel: +88-02 333351050-51", tempMisWidth + 260, tempMisHight + 67, "normal", 56);
      this.setPrintText(doc, "E-mail: info@aktelecom.net; help@aktelecom.net; Web: www.aktelecom.net", tempMisWidth + 260, tempMisHight + 78, "normal", 56);


      doc.setFontSize(10);
      doc.text(`MR Number: ${data.mr_number}`, (tempMisWidth + 10), tempMisHight + 135, { align: "left" });
      doc.text(`Payment By: ${data.payment_method}`, (tempMisWidth + 10), tempMisHight + 148, { align: "left" });

      doc.setFontSize(14);
      doc.text("OFFICIAL RECEIPT", tempMisWidth + 245, tempMisHight + 140, { align: "center" });

      doc.setFontSize(10);
      doc.text(`Received Date: ${data.received_date}`, (tempMisWidth + 380), tempMisHight + 135, { align: "left" });
      doc.text(`MR Date: ${data.mr_date}`, (tempMisWidth + 380), tempMisHight + 148, { align: "left" });


      doc.text(`Amount Tk: ${data.amount_tk}`, (tempMisWidth + 10), tempMisHight + 185, { align: "left" });
      doc.text(`In Word: ${data.amount_tk_word}`, (tempMisWidth + 220), tempMisHight + 185, { align: "left" });

      // if(data.payment_method == "CASH") {} else 

      if (data.payment_method == "BKash") {
        doc.text(`bKash Date: ${data.bkash_date}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });
        doc.text(`Transection ID: ${data.transection_id}`, (tempMisWidth + 180), tempMisHight + 200, { align: "left" });
        doc.text(`Reference: ${data.reference}`, (tempMisWidth + 330), tempMisHight + 200, { align: "left" });

      } else if (data.payment_method == "Chalan") {
        doc.text(`Chalan No: ${data.chalan_no}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });

      } else if (data.payment_method == "BANK") {
        doc.text(`Bank Name: ${data.bank_name}`, (tempMisWidth + 10), tempMisHight + 200, { align: "left" });
        doc.text(`Bank Branch: ${data.bank_branch}`, (tempMisWidth + 220), tempMisHight + 200, { align: "left" });
        doc.text(`Cheque No: ${data.cheque_number}`, (tempMisWidth + 10), tempMisHight + 215, { align: "left" });
        doc.text(`Cheque Date: ${data.cheque_date}`, (tempMisWidth + 220), tempMisHight + 215, { align: "left" });
      }

      doc.text(`Customer Name: ${data.customer_name}`, (tempMisWidth + 10), tempMisHight + 230, { align: "left" });
      doc.text(`This Receipt is valid only when signed by an authorized officer or a Rubber stamp.`, (tempMisWidth + 10), tempMisHight + 260, { align: "left" });
      doc.text(`Note: ${data.note}`, (tempMisWidth + 10), tempMisHight + 272, { align: "left" });
      doc.text(`Authorized Signature.`, (tempMisWidth + 395), tempMisHight + 325, { align: "center" });
      doc.text(`_____________________________`, (tempMisWidth + 315), tempMisHight + 308, { align: "left" });

      doc.text(data.copy_right_message, (tempMisWidth + 230), pageHeight - 10, { align: "center" });

      doc.save(`Payment invoice No ${data.invoice_no}.pdf`);

      // Auto print code
      doc.autoPrint();
      try {
        window.open(doc.output("bloburl"), "_blank");
      } catch (e) {
        console.log(e);
      }

    }
  },

  mounted() {
    areaRelatedAPI.districtList().then((response) => {
      this.districtList = response.data.data?.map((e) => {
        return { ...e, text: e?.name };
      });
    });

    customerAPI.getList().then((response) => {
      this.customerList = [
        ...this.customerList,
        ...response?.data?.data?.map((e) => {
          return { ...e, text: e?.name };
        }),
      ];
    });


    // customer list
    // customerAPI.getList().then((response) => {
    //   this.customerList = response.data.data;
    // });
    // list
    connectionTypeAPI.typeActiveList().then((response) => {
      this.customerTypeList = response.data.data;
    });
  },
};
</script>

<style scoped>
thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: #dbd4d4;
  border-style: solid;
  border-width: 1px;
  padding: 10px 5px;
}

.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

.card {
  border-radius: 1.5em;
  border: 1px solid white;
}

.card-header:first-child {
  border-radius: 1.5em;
}

.modal-backdrop.fade.show {
  opacity: 1 !important;
  display: none;
}

.modal-body.ct h5 {
  text-align: center;
}
</style>
